// import { AdminUserResult, AdminUsersResult } from "@futuri/cloudsso-client/src/client/types/admin";
import { Module } from "vuex";
import {
  ProductInstanceResult,
  AdminUserResult,
  LoginResult
} from "@futuri/cloudsso-client";
import { setCurrentClusterInstanceId, setSearchPrefix } from "./actions";
import {
  SET_CURRENT_CLUSTER_INSTANCE_ID,
  SET_SEARCH_PREFIX
} from "./mutations";
import { matchInstancesByPrefix } from "@futuri/cloudsso-client/src/instanceUtils";
import { matchUsersByPrefix } from "@futuri/cloudsso-client/src/userUtils";
import { filteredCardInstances, currentProduct } from "./getters";
import { notUndefined } from "@futuri/cloudsso-client/src/util";

export interface SessionModuleState {
  currentClusterInstanceId?: string;
  // clusterFilterCriteria?: SearchCriterion[]
  searchPrefix?: string;
}

const matchingInstances = (
  _state: any,
  getters: any,
  _rootState: any,
  rootGetters: any
): ProductInstanceResult[] | undefined => {
  const search = getters.searchPrefix;
  const instances =
    (rootGetters.availableInstances as ProductInstanceResult[]) ?? [];

  const matching = matchInstancesByPrefix(instances, search);
  return matching;
};

const matchingUsers = (
  _state: any,
  getters: any,
  _rootState: any,
  rootGetters: any
): AdminUserResult[] | undefined => {
  const search = getters.searchPrefix;
  // const users =  (rootGetters.allUsers as AdminUserResult[]) ?? []
  const users = (rootGetters?.portalData as LoginResult)?.users ?? [];

  const matching = matchUsersByPrefix(users, search).filter(notUndefined);
  return matching;
};

const sessionModule: Module<SessionModuleState, any> = {
  namespaced: true,
  state: {
    currentClusterInstanceId: undefined,
    // clusterFilterCriteria: undefined,
    searchPrefix: undefined
  },
  getters: {
    currentClusterInstanceId: state => state.currentClusterInstanceId,
    currentClusterInstance: (_state, getters, _rootState, rootGetters) => {
      const { currentClusterInstanceId } = getters;
      const allInstances = rootGetters["adminUserPost/allInstances"];
      return allInstances?.filter(
        (inst: ProductInstanceResult) =>
          inst.instanceId === currentClusterInstanceId
      )[0];
    },
    // clusterFilterCriteria: (state) => state.clusterFilterCriteria
    // currentProduct: () => {
    //   const product = router.currentRoute?.params?.productType;
    //   return product;
    // },
    searchPrefix: state => state.searchPrefix,

    matchingInstances,
    matchingUsers,

    currentProduct,
    // filteredCardInstances,

    // async boundInstances(state, { rootGetters }) {
    //   const { availableInstances, currentUser } = rootGetters
    //   const res =  await boundInstances()
    // }

    filteredCardInstances
  },
  actions: {
    setCurrentClusterInstanceId,
    setSearchPrefix
  },
  mutations: {
    SET_CURRENT_CLUSTER_INSTANCE_ID,
    SET_SEARCH_PREFIX
  }
};

export default sessionModule;
